exports.ACCESS_TOKEN = 'accessToken';
exports.EXPIRATION = 'expires';
exports.ID_TOKEN = 'idToken';
exports.REFRESH_TOKEN = 'refreshToken';
exports.IDENTITY_SWITCHED_CONTAINER_AT = 'indetitySwitchedContainerAt';

